//#region src/schema/helpers/should-display-description.ts
var e = (e, t) => !e || e.allOf ? null : t && e.description ? t === e.description ? t : `${t}\n\n${e.description}` : t || e.description || null;
//#endregion
export { e as shouldDisplayDescription };

//# sourceMappingURL=should-display-description.js.map